const GoTop = () => {
    const buttonScrollTo = document.querySelectorAll('[target="_scrollto"]');
    const scrollToTop = document.querySelector('.gototop');
    buttonScrollTo.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            window.scroll({
                top: 0,
                behavior: 'smooth',
            });
        });
    });

};

export default GoTop;